import { ChangeDetectionStrategy, Component, EnvironmentInjector, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesHelper } from '@helpers/routes-helper';
import { AuthenticationService } from '@services/authentication';
import { Language, LanguageService } from '@services/language';
import { APP_ROUTES } from 'app/constants';

@Component({
    selector: 'app-topbar-dropdown',
    templateUrl: './topbar-dropdown.component.html',
    styleUrls: ['./topbar-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopbarDropdownComponent implements OnInit {
    public firstName: string;
    public language: Language;
    public languages: Language[];
    private readonly authenticationService = inject(AuthenticationService);
    private readonly languageService = inject(LanguageService);
    private readonly injector = inject(EnvironmentInjector);
    private readonly router = inject(Router);

    public ngOnInit() {
        this.firstName = this.authenticationService.getUser().fullname;
        this.language = this.languageService.getLanguage();
        this.languages = this.languageService.getLanguages();
    }

    public changeLanguage(language: Language) {
        this.languageService.setLanguage(language);
        this.language = this.languageService.getLanguage();
    }

    public async userProfile() {
        await this.router.navigate([APP_ROUTES.UserProfile]);
    }

    public logout() {
        this.injector.runInContext(() => {
            RoutesHelper.RunInContext.navigateToLoginAndTriggerLogout();
        });
    }
}
